import React, { useEffect } from "react"
import { useState } from "react"
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react"
import { ChevronUpDownIcon } from "@heroicons/react/16/solid"
import { CheckIcon } from "@heroicons/react/20/solid"

export default function Select({ items, label, itemChangeHandler, error='', selectedItemId }) {
  const [selected, setSelected] = useState(items[0])
  
  useEffect(() => {
    if (selectedItemId != null) {
      const item = items.find((t) => t.id === selectedItemId)
      if (item) {
        setSelected(item)
      }
    }
  }, [selectedItemId])

  useEffect(() => {
    const item = items.find((t) => t.name === selected.name)
    if (item) {
      itemChangeHandler(item)
    }
  }, [selected])

  return (
    <Listbox value={selected} onChange={setSelected}>
      <Label className="block text-sm/6 font-medium text-gray-900">
        {label}
      </Label>
      <div className="relative mt-1">
        <ListboxButton className={`grid w-full cursor-default grid-cols-1 rounded-md bg-white py-[7px] pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 ${ error === '' ? "outline-gray-300" : "outline-red-700"} focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6`} >
        <span className="col-start-1 row-start-1 truncate pr-6" >
            {selected.name}
        </span>
        <ChevronUpDownIcon
            aria-hidden="true"
            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
        />
        </ListboxButton>

        <ListboxOptions
        transition
        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
        {items.map(item => (
            <ListboxOption
              key={item.id}
              value={item} disabled={item.disabled ? item.disabled : false}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-primary data-[focus]:text-white data-[focus]:outline-none"
            >
            <span className="block truncate font-normal group-data-[selected]:font-semibold">
                {item.name}
            </span>

            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-primary group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                <CheckIcon aria-hidden="true" className="size-5" />
            </span>
            </ListboxOption>
        ))}
        </ListboxOptions>
      </div>
        
      <label className="text-red-700 italic text-nowrap">{error}</label>
    </Listbox>
  )
}
